module.exports = __webpack_public_path__ + "img/shoe rack_A.47bd9c77.png";